import { QRCode } from "antd";
import { useContext } from "react";
import { Link } from "react-router";
import { CustomerContext } from "../../providers";
import { Text } from "../tailwind/text";

export const SendReceiveMessages = () => {
  const { customer } = useContext(CustomerContext);

  return (
    <div className="">
      <Text className="mb-3">
        Try sending a message to your new WhatsApp account.
      </Text>
      {customer?.phoneNumber && (
        <>
          <Text className="mb-1">
            👉
            <Link
              className="text-pink"
              target="_blank"
              to={`https://wa.me/${customer.phoneNumber}`}
            >
              Open WhatsApp to text +{customer.phoneNumber}
            </Link>
          </Text>
          <QRCode
            value={"https://wa.me/" + customer.phoneNumber}
            className="mb-3"
          />
        </>
      )}
      <Text>Then check if it appears well on your Conversations tab.</Text>

      <Text>If you see a new conversation, it's all good.</Text>
    </div>
  );
};
